(() => {
  const root = document.querySelector('[data-worktop-variant-configurator]');
  if (!root) return;

  const parseJson = (selector, fallback) => {
    const el = root.querySelector(selector);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent || ''); } catch (_) { return fallback; }
  };
  const config = parseJson('[data-worktop-config]', {});
  const options = parseJson('[data-worktop-options]', []);
  const metaobjectProducts = parseJson('[data-worktop-accessory-products]', []);
  const shopifyProducts = parseJson('[data-worktop-shopify-accessory-products]', []);
  const baseProducts = normalizeAccessoryProducts([...metaobjectProducts, ...shopifyProducts]);
  const accessoryProducts = baseProducts;
  const storageKey = 'madone-worktop-variant-' + (config.version || 'test');
  const isWizard = config.experienceMode === 'guided_wizard';
  const isEditorial = config.contentMode === 'editorial_product_page';
  injectDynamicStyles();
  root.classList.toggle('is-wizard', isWizard);
  root.classList.toggle('is-editorial', isEditorial);

  const els = {
    finish: root.querySelector('[data-worktop-finish]'),
    thickness: root.querySelector('[data-worktop-thickness]'),
    pieces: root.querySelector('[data-worktop-pieces]'),
    unitOptions: root.querySelector('[data-worktop-unit-options]'),
    accessoryOptions: root.querySelector('[data-worktop-accessory-options]'),
    accessoryPanel: root.querySelector('[data-worktop-accessory-panel]'),
    steps: root.querySelector('[data-worktop-steps]'),
    stepButtons: Array.from(root.querySelectorAll('[data-worktop-step-button]')),
    stepPanels: Array.from(root.querySelectorAll('[data-worktop-step]')),
    wizardNav: root.querySelector('[data-worktop-wizard-nav]'),
    prevStep: root.querySelector('[data-worktop-prev-step]'),
    nextStep: root.querySelector('[data-worktop-next-step]'),
    wizardFormHost: root.querySelector('[data-worktop-wizard-form-host]'),
    summaryFormHost: root.querySelector('[data-worktop-summary-form-host]'),
    backsplash: root.querySelector('[data-worktop-backsplash]'),
    form: root.querySelector('[data-worktop-endpoint-form]'),
    payload: root.querySelector('[data-worktop-payload]'),
    status: root.querySelector('[data-worktop-form-status]'),
    area: root.querySelector('[data-worktop-area]'),
    baseTotal: root.querySelector('[data-worktop-base-total]'),
    cutsTotal: root.querySelector('[data-worktop-cuts-total]'),
    backsplashTotal: root.querySelector('[data-worktop-backsplash-total]'),
    accessoriesTotal: root.querySelector('[data-worktop-accessories-total]'),
    grandTotal: root.querySelector('[data-worktop-grand-total]'),
    mobileTotal: root.querySelector('[data-worktop-mobile-total]'),
    summaryLines: root.querySelector('[data-worktop-summary-lines]'),
    summary: root.querySelector('[data-worktop-summary]'),
    submit: root.querySelector('.worktop-variant__submit'),
    contactFields: Array.from(root.querySelectorAll('[data-worktop-contact-field]')),
    mobileToggle: root.querySelector('[data-worktop-mobile-toggle]'),
    closeSummary: root.querySelector('[data-worktop-summary-close]'),
    overlay: root.querySelector('[data-worktop-overlay]'),
    disclaimer: root.querySelector('[data-worktop-disclaimer]'),
    picker: root.querySelector('[data-worktop-accessory-picker]'),
    pickerOverlay: root.querySelector('[data-worktop-picker-overlay]'),
    pickerClose: root.querySelector('[data-worktop-picker-close]'),
    pickerTitle: root.querySelector('[data-worktop-picker-title]'),
    pickerSearch: root.querySelector('[data-worktop-picker-search]'),
    pickerMaterial: root.querySelector('[data-worktop-picker-material]'),
    pickerBrand: root.querySelector('[data-worktop-picker-brand]'),
    pickerThirdLabel: root.querySelector('[data-worktop-picker-third-label]'),
    pickerInstallation: root.querySelector('[data-worktop-picker-installation]'),
    pickerSort: root.querySelector('[data-worktop-picker-sort]'),
    pickerCount: root.querySelector('[data-worktop-picker-count]'),
    pickerGeneric: root.querySelector('[data-worktop-picker-generic]'),
    pickerGrid: root.querySelector('[data-worktop-picker-grid]'),
    pickerLoadMore: root.querySelector('[data-worktop-picker-load-more]'),
  };

  function normalizePiece(piece) {
    return {
      lengthMm: Number(piece?.lengthMm || 0),
      widthMm: Number(piece?.widthMm || 0),
      quantity: Number(piece?.quantity || 1) || 1,
    };
  }

  function normalizePieces(pieces) {
    return (Array.isArray(pieces) ? pieces : []).map(normalizePiece);
  }

  function normalizeBacksplashPiece(piece) {
    return {
      lengthMm: Number(piece?.lengthMm || 0),
      heightMm: Number(piece?.heightMm || 0),
      quantity: Number(piece?.quantity || 1) || 1,
      outletCutouts: Number(piece?.outletCutouts || 0) || 0,
    };
  }

  function defaultBacksplashPiece() {
    const defaults = config.backsplashDefaults || {};
    const first = Array.isArray(defaults.pieces) && defaults.pieces.length ? defaults.pieces[0] : defaults;
    return normalizeBacksplashPiece({ lengthMm: 2400, heightMm: 300, quantity: 1, outletCutouts: 0, ...first });
  }

  function normalizeBacksplash(source) {
    const defaults = config.backsplashDefaults || {};
    const input = source || defaults;
    const sourcePieces = Array.isArray(input.pieces) && input.pieces.length
      ? input.pieces
      : Array.isArray(defaults.pieces) && defaults.pieces.length
        ? defaults.pieces
        : [input];
    const pieces = sourcePieces.map(normalizeBacksplashPiece);
    return {
      enabled: Boolean(input.enabled),
      optionHandle: input.optionHandle || defaults.optionHandle || 'credence-12-mm',
      pieces: pieces.length ? pieces : [defaultBacksplashPiece()],
    };
  }

  const saved = loadSavedState();
  const state = {
    requestId: createRequestId(),
    finish: config.defaultFinish || 'Mate',
    thickness: config.defaultThickness || '12 mm',
    pieces: normalizePieces(config.defaultPieces?.length ? config.defaultPieces : [{ lengthMm: 2400, widthMm: 650, quantity: 1 }]),
    quantities: {},
    accessoryProducts: {},
    accessoryProductVariants: {},
    accessoryRequests: {},
    backsplash: normalizeBacksplash(config.backsplashDefaults || { enabled: false, pieces: [{ lengthMm: 2400, heightMm: 300, quantity: 1, outletCutouts: 0 }] }),
    currentStep: 1,
    picker: { category: 'evier', query: '', material: 'all', brand: 'all', installation: 'all', sort: 'featured', visible: 12 },
  };
  if (saved?.state) {
    state.finish = saved.state.finish || state.finish;
    state.thickness = saved.state.thickness || state.thickness;
    state.pieces = Array.isArray(saved.state.pieces) && saved.state.pieces.length ? normalizePieces(saved.state.pieces) : state.pieces;
    state.quantities = saved.state.quantities || state.quantities;
    state.accessoryProducts = saved.state.accessoryProducts || state.accessoryProducts;
    state.accessoryProductVariants = saved.state.accessoryProductVariants || state.accessoryProductVariants;
    state.accessoryRequests = saved.state.accessoryRequests || state.accessoryRequests;
    state.backsplash = normalizeBacksplash({ ...state.backsplash, ...(saved.state.backsplash || {}) });
    state.currentStep = isWizard ? Number(saved.state.currentStep || 1) : 1;
    state.picker = { ...state.picker, ...(saved.state.picker || {}) };
  }
  const validOptionHandles = new Set(options.map(option => option.handle));
  state.quantities = Object.fromEntries(Object.entries(state.quantities).filter(([handle, quantity]) => validOptionHandles.has(handle) && Number(quantity || 0) > 0));
  options.filter(option => option.category === 'accessoire').forEach(option => { delete state.quantities[option.handle]; });

  if (els.disclaimer) els.disclaimer.textContent = config.disclaimer || '';
  restoreContactFields(saved?.contact || {});

  const formatMoney = value => Number(value || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  const formatArea = value => Number(value || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' m²';
  const numeric = value => Number.parseFloat(String(value ?? '').replace(',', '.')) || 0;
  const optionByHandle = handle => options.find(option => option.handle === handle);
  const productByHandle = handle => accessoryProducts.find(product => product.handle === handle);
  const accessoryOptionByCategory = category => options.find(option => option.category === 'accessoire' && option.productCategory === category);

  function nullableNumber(value) {
    if (value === '' || value === null || value === undefined) return null;
    const number = Number.parseFloat(String(value).replace(',', '.'));
    return Number.isFinite(number) ? number : null;
  }

  function normalizeAccessoryProducts(rows) {
    return (Array.isArray(rows) ? rows : [])
      .map(row => {
        const sourceType = row.sourceType || row.source_type || 'metaobject';
        const pricingMode = row.pricingMode || row.pricing_model || 'quote_only';
        const price = nullableNumber(row.pricePublicTtc ?? row.price_public_ttc ?? row.price_ttc);
        const variants = normalizeProductVariants(row.variants);
        const firstVariant = variants[0] || {};
        return {
          ...row,
          sourceType,
          source_type: sourceType,
          pricingMode,
          pricing_model: pricingMode,
          brand: row.brand || row.vendor || '',
          vendor: row.vendor || row.brand || '',
          reference: row.reference || firstVariant.reference || '',
          color: row.color || firstVariant.color || firstVariant.label || '',
          image_url: row.image_url || row.imageUrl || firstVariant.image_url || firstVariant.imageUrl || row.source_image_url || row.sourceImageUrl || '',
          source_url: row.source_url || row.sourceUrl || firstVariant.source_url || firstVariant.sourceUrl || '',
          price_ttc: price ?? nullableNumber(firstVariant.price_ttc ?? firstVariant.pricePublicTtc ?? firstVariant.price_public_ttc),
          price_public_ttc: price ?? nullableNumber(firstVariant.price_ttc ?? firstVariant.pricePublicTtc ?? firstVariant.price_public_ttc),
          productId: row.productId || row.product_id || '',
          product_id: row.product_id || row.productId || '',
          variantId: row.variantId || row.variant_id || firstVariant.variantId || firstVariant.variant_id || '',
          variant_id: row.variant_id || row.variantId || firstVariant.variantId || firstVariant.variant_id || '',
          availability: row.availability || '',
          variants,
          technical: row.technical || {},
          sort_order: Number(row.sort_order || row.sortOrder || 0) || 0,
        };
      })
      .filter(row => row.handle && row.title && row.category)
      .sort((a, b) => a.sort_order - b.sort_order || String(a.title).localeCompare(String(b.title), 'fr'));
  }

  function normalizeProductVariants(variants) {
    const rows = Array.isArray(variants) && variants.length ? variants : [];
    return rows.map(variant => {
      if (typeof variant === 'string') return { label: variant, color: variant };
      if (!variant || typeof variant !== 'object') return null;
      const label = variant.label || variant.color || variant.reference || '';
      if (!label) return null;
      return {
        ...variant,
        label,
        color: variant.color || label,
        reference: variant.reference || '',
        image_url: variant.image_url || variant.imageUrl || variant.source_image_url || variant.sourceImageUrl || '',
        source_url: variant.source_url || variant.sourceUrl || '',
        productId: variant.productId || variant.product_id || '',
        product_id: variant.product_id || variant.productId || '',
        variantId: variant.variantId || variant.variant_id || '',
        variant_id: variant.variant_id || variant.variantId || '',
        price_ttc: nullableNumber(variant.price_ttc ?? variant.pricePublicTtc ?? variant.price_public_ttc),
        price_public_ttc: nullableNumber(variant.price_public_ttc ?? variant.pricePublicTtc ?? variant.price_ttc),
      };
    }).filter(Boolean);
  }

  function selectedVariantFor(product, selectedLabel) {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const label = typeof selectedLabel === 'object' ? selectedLabel?.label : selectedLabel;
    return variants.find(variant => variant.label === label) || variants[0] || {};
  }

  function productDisplay(product, selectedLabel) {
    const label = typeof selectedLabel === 'object' ? selectedLabel?.label : selectedLabel;
    const variant = selectedVariantFor(product, label);
    return {
      label: variant.label || label || '',
      color: variant.color || product.color || '',
      reference: variant.reference || product.reference || '',
      image_url: variant.image_url || product.image_url || '',
      source_url: variant.source_url || product.source_url || '',
      productId: variant.productId || variant.product_id || product.productId || product.product_id || '',
      variantId: variant.variantId || variant.variant_id || product.variantId || product.variant_id || '',
      price_ttc: nullableNumber(variant.price_ttc ?? variant.price_public_ttc ?? product.price_ttc),
      price_public_ttc: nullableNumber(variant.price_public_ttc ?? variant.price_ttc ?? product.price_public_ttc ?? product.price_ttc),
    };
  }

  function materialFilterValue(product) {
    if (product.category === 'prise') return product.technical?.finish || product.material || product.range || '';
    if (product.category === 'mitigeur') {
      const material = String(product.material || product.range || '').toLowerCase();
      if (material.includes('316')) return 'Inox 316';
      if (material.includes('inox')) return 'Inox';
      return product.material || product.range || '';
    }
    const material = String(product.material || product.range || '').toLowerCase();
    if (material.includes('bradanit')) return 'BRADANIT®';
    if (material.includes('ceramique') || material.includes('céramique')) return 'Céramique';
    if (material.includes('inox')) return 'Inox';
    return product.material || product.range || '';
  }

  function installationFilterValues(product) {
    const technical = product.technical || {};
    const rows = technical.installationFilter || technical.installation || [];
    return (Array.isArray(rows) ? rows : [rows]).filter(Boolean);
  }

  function thirdFilterConfig(category) {
    if (category === 'mitigeur') return { label: 'Fonction', allLabel: 'Toutes les fonctions', values: faucetFunctionFilterValues };
    if (category === 'prise') return { label: 'Type', allLabel: 'Tous les types', values: socketTypeFilterValues };
    return { label: 'Type de pose', allLabel: 'Tous les types de pose', values: installationFilterValues };
  }

  function faucetFunctionFilterValues(product) {
    const technical = product.technical || {};
    const rows = technical.functionFilter || technical.function || technical.featureFilter || [];
    return (Array.isArray(rows) ? rows : [rows]).filter(Boolean);
  }

  function socketTypeFilterValues(product) {
    return product.category === 'prise' ? ['Prises affleurantes'] : [];
  }

  function activeThirdFilterValues(product) {
    return thirdFilterConfig(state.picker.category || product.category).values(product);
  }

  function accessoryImageScale(category) {
    if (category === 'evier') return '1.34';
    if (category === 'mitigeur') return '1.18';
    if (category === 'prise') return '1.08';
    return '1';
  }

  function accessoryTypeImageScale(category) {
    if (category === 'evier') return '1';
    if (category === 'mitigeur') return '1';
    if (category === 'prise') return '1';
    return '1';
  }

  function selectedAccessoryImageScale(category) {
    if (category === 'evier') return '.92';
    if (category === 'mitigeur') return '.9';
    if (category === 'prise') return '.92';
    return '.94';
  }

  function injectDynamicStyles() {
    if (document.getElementById('madone-worktop-variant-dynamic-css')) return;
    const style = document.createElement('style');
    style.id = 'madone-worktop-variant-dynamic-css';
    style.textContent = [
      '.worktop-variant,.worktop-variant *{box-sizing:border-box}',
      '.worktop-variant{overflow-x:clip}',
      '.worktop-variant.is-editorial .worktop-variant__layout{grid-template-columns:minmax(0,1fr) minmax(330px,400px);gap:34px;align-items:start;margin-top:8px}',
      '.worktop-variant.is-editorial .worktop-variant__content{min-width:0}',
      '.worktop-variant.is-editorial .worktop-variant__summary{top:calc(var(--sticky-header-height,72px) + 12px);align-self:start}',
      '.worktop-variant__config-heading{margin-bottom:24px}',
      '.worktop-variant__config-heading h2{margin:0 0 10px;font-size:clamp(2.5rem,3vw,3.6rem);line-height:1.08}',
      '.worktop-variant__group h3,.worktop-variant__accessory-panel h3{margin:0 0 16px;font-size:2.2rem;line-height:1.15}',
      '.worktop-variant__group-head h3{margin:0}',
      '.worktop-variant__summary-title{margin:0 0 18px;font-family:var(--font-heading-family);font-size:2.2rem;line-height:1.15}',
      '.worktop-variant__totals>.worktop-variant__grand-total{display:grid!important;grid-template-columns:minmax(0,1fr) max-content;align-items:baseline;gap:8px;padding:8px 0 4px!important;font-size:1.7rem}',
      '.worktop-variant__totals>.worktop-variant__grand-total dt,.worktop-variant__totals>.worktop-variant__grand-total dd{margin:0!important;white-space:nowrap}',
      '.worktop-variant__total-asterisk{margin-left:2px;font-size:.62em;line-height:0;vertical-align:super}',
      '.worktop-variant__summary .worktop-variant__total-note{margin:0 0 10px!important;padding:0!important;color:rgba(var(--color-foreground),.62);font-size:1.1rem;font-weight:400;line-height:1.35;text-align:left}',
      '.worktop-variant__media,.worktop-variant__content,.worktop-variant__summary-inner,.worktop-variant__seo,.worktop-variant__option,.worktop-variant__product,.worktop-variant__type-card,.worktop-variant__selected-row{min-width:0}',
      '.worktop-variant__title{font-size:clamp(2.6rem,4vw,4.4rem);line-height:1.08;overflow-wrap:anywhere;hyphens:auto}',
      '.worktop-variant__lead,.worktop-variant__help,.worktop-variant__notice{overflow-wrap:anywhere}',
      '.worktop-variant__eyebrow,.worktop-variant__summary-label,.worktop-variant__product-badge{letter-spacing:0}',
      '.worktop-variant__option,.worktop-variant__product{overflow:hidden;width:100%}',
      '.worktop-variant__option-body,.worktop-variant__product-body{min-width:0}',
      '.worktop-variant__option-title,.worktop-variant__product-title,.worktop-variant__product-price,.worktop-variant__product-description,.worktop-variant__type-title,.worktop-variant__type-meta,.worktop-variant__selected-meta{overflow-wrap:anywhere}',
      '.worktop-variant__option-grid{grid-template-columns:repeat(2,minmax(0,1fr))}',
      '.worktop-variant__stepper{display:grid!important;grid-template-columns:minmax(42px,56px) minmax(0,1fr) minmax(42px,56px)!important;align-items:center;width:100%;min-width:0;max-width:100%;overflow:hidden}',
      '.worktop-variant__stepper button{width:auto!important;min-width:0!important;max-width:100%;height:44px;padding:0!important}',
      '.worktop-variant__stepper span{min-width:0;padding:0 6px;text-align:center;overflow:hidden;text-overflow:ellipsis}',
      '.worktop-variant__edge-button,.worktop-variant__product-button,.worktop-variant__ghost-button,.worktop-variant__wizard-nav .btn,.worktop-variant__submit{min-width:0!important;max-width:100%;white-space:normal;overflow-wrap:anywhere;text-align:center}',
      '.worktop-variant__steps{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px;margin:0 0 26px}',
      '.worktop-variant__steps[hidden],.worktop-variant__wizard-nav[hidden]{display:none}',
      '.worktop-variant__steps button{display:flex;align-items:center;justify-content:center;min-width:0!important;min-height:48px;padding:10px 8px;border:1px solid rgba(var(--color-foreground),.16);background:rgba(var(--color-foreground),.035);color:rgb(var(--color-foreground));cursor:pointer;font:inherit;font-size:clamp(1.18rem,1.2vw,1.45rem);font-weight:700;line-height:1.15;text-align:center;white-space:normal;overflow-wrap:anywhere}',
      '.worktop-variant__steps button.is-active{background:rgb(var(--color-foreground));color:rgb(var(--color-background))}',
      '.worktop-variant__step{display:block}',
      '.worktop-variant:not(.is-wizard) [data-worktop-step="4"]{display:none}',
      '.worktop-variant.is-wizard .worktop-variant__step{display:none}',
      '.worktop-variant.is-wizard .worktop-variant__step.is-active{display:block}',
      '.worktop-variant__wizard-nav{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);justify-content:space-between;gap:12px;margin-top:28px;padding-top:20px;border-top:1px solid rgba(var(--color-foreground),.14)}',
      '.worktop-variant__wizard-nav.is-final-step{grid-template-columns:minmax(0,1fr)}',
      '.worktop-variant__wizard-nav.is-final-step [data-worktop-next-step]{display:none!important}',
      '.worktop-variant__ghost-button{min-height:44px;border:1px solid rgba(var(--color-foreground),.18);background:rgb(var(--color-background));color:rgb(var(--color-foreground));padding:10px 14px;cursor:pointer;font:inherit;font-weight:700}',
      '.worktop-variant__form-status{border-radius:0;margin-top:2px;padding:0;line-height:1.35}',
      '.worktop-variant__form-status.is-success{display:block;min-height:auto;padding:16px 18px;border:1px solid #245f43;background:#eef7f1;color:#245f43;font-size:1.55rem;font-weight:700}',
      '.worktop-variant__form-status.is-error{display:block;min-height:auto;padding:14px 16px;border:1px solid #9f1d1d;background:#fff1f1;color:#9f1d1d;font-size:1.4rem;font-weight:700}',
      '.worktop-variant__checkbox{display:flex;align-items:flex-start;gap:12px;width:100%;margin:14px 0 18px;padding:14px 16px;border:1px solid rgba(var(--color-foreground),.16);background:rgba(var(--color-foreground),.035);cursor:pointer;line-height:1.35}',
      '.worktop-variant__checkbox input{flex:0 0 auto;width:20px;height:20px;margin:1px 0 0}',
      '.worktop-variant__checkbox span{display:grid;gap:2px;min-width:0}',
      '.worktop-variant__checkbox strong{font-size:1.45rem}',
      '.worktop-variant__checkbox small{color:rgba(var(--color-foreground),.68);font-size:1.25rem}',
      '.worktop-variant__backsplash-list{display:grid;gap:16px}',
      '.worktop-variant__backsplash-list[hidden]{display:none}',
      '.worktop-variant__backsplash-item{padding:16px 0;border-top:1px solid rgba(var(--color-foreground),.14)}',
      '.worktop-variant__backsplash-item:first-child{border-top:0;padding-top:0}',
      '.worktop-variant__accessory-types{display:grid;grid-template-columns:repeat(auto-fit,minmax(min(230px,100%),1fr));gap:14px}',
      '.worktop-variant__type-card{display:grid;width:100%;height:auto;min-width:0;min-height:0;grid-template-rows:auto 1fr;gap:0;border:1px solid rgba(var(--color-foreground),.14);background:rgb(var(--color-background));padding:0;text-align:left;color:rgb(var(--color-foreground));cursor:pointer;font:inherit;appearance:none;-webkit-appearance:none;border-radius:0;overflow:hidden}',
      '.worktop-variant__type-card.is-selected{border-color:rgb(var(--color-foreground));box-shadow:inset 0 0 0 1px rgb(var(--color-foreground))}',
      '.worktop-variant__media-frame{position:relative;display:grid;place-items:center;width:100%;aspect-ratio:1.55/1;overflow:hidden;background:#fff;border-bottom:1px solid rgba(var(--color-foreground),.1)}',
      '.worktop-variant__media-frame img{position:absolute;inset:0;display:block;width:100%;height:100%;max-width:none;max-height:none;aspect-ratio:auto;object-fit:contain;border:0;background:transparent;transform:scale(var(--accessory-image-scale,1));transform-origin:center}',
      '.worktop-variant__media-frame--type{aspect-ratio:1.45/1;background:#fff}',
      '.worktop-variant__media-frame--type img{inset:10px;width:calc(100% - 20px);height:calc(100% - 20px);padding:0;object-position:center center}',
      '.worktop-variant__media-frame--selected{width:64px;aspect-ratio:1/1;border-bottom:0}',
      '.worktop-variant__type-body{display:grid;width:100%;min-width:0;max-width:100%;gap:6px;padding:14px;overflow:hidden}',
      '.worktop-variant__type-title{margin:0;font-size:1.5rem;font-weight:700}',
      '.worktop-variant__type-title,.worktop-variant__type-meta,.worktop-variant__type-action{display:block;min-width:0;max-width:100%;white-space:normal;overflow-wrap:anywhere}',
      '.worktop-variant__type-meta,.worktop-variant__selected-meta{margin:0;color:rgba(var(--color-foreground),.68);font-size:1.25rem;line-height:1.35;text-transform:none}',
      '.worktop-variant__type-action{display:block;margin-top:4px;font-weight:700;text-decoration:underline;text-underline-offset:3px}',
      '.worktop-variant__selected-list{display:grid;gap:10px}',
      '.worktop-variant__selected-row{display:grid;grid-template-columns:64px minmax(0,1fr) minmax(128px,176px);gap:12px;align-items:center;padding:10px;border:1px solid rgba(var(--color-foreground),.12);overflow:hidden}',
      '.worktop-variant__option,.worktop-variant__product{overflow:hidden}',
      '.worktop-variant__option-body,.worktop-variant__product-body,.worktop-variant__type-body{position:relative;z-index:1;background:rgb(var(--color-background))}',
      '.worktop-variant__selected-row .worktop-variant__media-frame{width:64px;aspect-ratio:1/1;border-bottom:0}',
      '.worktop-variant__selected-row .worktop-variant__media-frame img{inset:4px;width:calc(100% - 8px);height:calc(100% - 8px);aspect-ratio:auto;border:0;background:transparent;transform:scale(var(--accessory-image-scale,.94))}',
      '.worktop-variant__selected-row strong{display:block;font-size:1.35rem}',
      '.worktop-variant__picker-overlay{position:fixed;inset:0;width:100vw;height:100vh;z-index:90;display:block!important;background:rgba(0,0,0,.52);backdrop-filter:blur(1px)}',
      '.worktop-variant__picker-overlay[hidden],.worktop-variant__picker[hidden]{display:none!important}',
      '.worktop-variant__picker{position:fixed;z-index:91;top:50%;right:auto;bottom:auto;left:50%;transform:translate(-50%,-50%);width:min(980px,calc(100vw - 48px));max-height:min(86vh,860px);overflow:auto;background:rgb(var(--color-background));color:rgb(var(--color-foreground));border:1px solid rgba(var(--color-foreground),.18);box-shadow:0 24px 90px rgba(0,0,0,.32);padding:0}',
      '.worktop-variant__picker-head{position:sticky;top:0;z-index:2;display:flex;align-items:flex-start;justify-content:space-between;gap:18px;margin:0;padding:20px 22px 16px;background:rgb(var(--color-background));border-bottom:1px solid rgba(var(--color-foreground),.12)}',
      '.worktop-variant__picker-head h3{margin:0;font-size:clamp(2.1rem,2.4vw,2.8rem);line-height:1.1;overflow-wrap:anywhere}',
      '.worktop-variant__picker .worktop-variant__summary-close{display:grid;position:static;flex:0 0 40px;width:40px;height:40px}',
      '.worktop-variant__picker-tools{display:grid;grid-template-columns:minmax(0,1.4fr) repeat(4,minmax(0,1fr));gap:12px;margin:0;padding:18px 22px 10px}',
      '.worktop-variant__picker [data-worktop-picker-count]{margin:0;padding:0 22px 14px}',
      '.worktop-variant__generic-request{display:grid;grid-template-columns:minmax(0,1fr) minmax(154px,220px);gap:14px;align-items:center;margin:0 22px 18px;padding:14px;border:1px solid rgba(var(--color-foreground),.14);background:rgba(var(--color-foreground),.035)}',
      '.worktop-variant__generic-request h3{margin:0 0 6px;font-size:1.45rem;line-height:1.2}',
      '.worktop-variant__generic-request p{margin:0;color:rgba(var(--color-foreground),.68);font-size:1.25rem;line-height:1.35}',
      '.worktop-variant__brand-note{margin:0 22px 12px;padding:0 2px;color:rgba(var(--color-foreground),.72);font-size:1.25rem;line-height:1.4;font-weight:600}',
      '.worktop-variant__generic-request-action{display:grid;gap:8px;min-width:0}',
      '.worktop-variant__generic-request-status{margin:0;font-size:1.22rem;font-weight:700;text-align:center}',
      '.worktop-variant__picker-grid,.worktop-variant__picker .worktop-variant__product-grid{padding:0 22px 22px}',
      '.worktop-variant__load-more{width:calc(100% - 44px);margin:0 22px 22px}',
      '.worktop-variant__product-grid.is-picker-grid{grid-template-columns:repeat(3,minmax(0,1fr))}',
      'body.worktop-picker-open{overflow:hidden}',
      '@media (min-width:981px){.worktop-variant__steps button{font-size:1.12rem;padding:8px 5px;white-space:nowrap;overflow-wrap:normal}}',
      '@media (max-width:1180px){.worktop-variant__steps{grid-template-columns:repeat(2,minmax(0,1fr))}.worktop-variant__wizard-nav{grid-template-columns:minmax(0,1fr) minmax(0,1fr)}.worktop-variant__steps button{min-height:50px;font-size:1.25rem}}',
      '@media (max-width:1080px){.worktop-variant.is-editorial .worktop-variant__layout{grid-template-columns:1fr}}',
      '@media (max-width:980px){.worktop-variant__accessory-types,.worktop-variant__product-grid.is-picker-grid{grid-template-columns:repeat(2,minmax(0,1fr))}.worktop-variant__picker-tools{grid-template-columns:1fr}.worktop-variant__generic-request{grid-template-columns:1fr}.worktop-variant__picker{width:min(760px,calc(100vw - 36px))}}',
      '@media (max-width:767px){.worktop-variant__layout,.worktop-variant__controls,.worktop-variant__piece-grid,.worktop-variant__backsplash-grid,.worktop-variant__option-grid,.worktop-variant__product-grid,.worktop-variant__seo-grid,.worktop-variant__contact-grid{grid-template-columns:1fr!important}.worktop-variant__media,.worktop-variant__content,.worktop-variant__seo{width:100%;max-width:100%}.worktop-variant__title{font-size:2.45rem}.worktop-variant__steps{grid-template-columns:1fr 1fr}.worktop-variant__steps button{padding:9px 6px;font-size:1.18rem}.worktop-variant__summary{position:fixed;inset:auto 0 0;max-height:88vh;max-height:88dvh;overflow:auto;overscroll-behavior:contain;transform:translate3d(0,calc(100% + 24px),0);visibility:hidden;pointer-events:none;transition:transform .24s ease,visibility 0s linear .24s}.worktop-variant.is-summary-open .worktop-variant__summary{transform:translate3d(0,0,0);visibility:visible;pointer-events:auto;transition:transform .24s ease}.worktop-variant.is-wizard .worktop-variant__summary{display:none!important}.worktop-variant.is-wizard.is-summary-open .worktop-variant__drawer-overlay{display:none!important}.worktop-variant__accessory-types,.worktop-variant__product-grid.is-picker-grid{grid-template-columns:1fr!important}.worktop-variant__picker{top:auto;right:0;bottom:0;left:0;width:100%;max-width:100%;max-height:92vh;transform:none;border-right:0;border-bottom:0;border-left:0;padding:0}.worktop-variant__picker-head{padding:18px 16px 14px}.worktop-variant__picker-tools{padding:16px 16px 10px}.worktop-variant__picker [data-worktop-picker-count]{padding:0 16px 12px}.worktop-variant__generic-request{margin:0 16px 16px}.worktop-variant__picker-grid,.worktop-variant__picker .worktop-variant__product-grid{padding:0 16px 18px}.worktop-variant__load-more{width:calc(100% - 32px);margin:0 16px 18px}.worktop-variant__selected-row{grid-template-columns:58px minmax(0,1fr)}.worktop-variant__selected-row .worktop-variant__media-frame{width:58px}.worktop-variant__selected-row .worktop-variant__media-frame img{width:100%;height:100%}.worktop-variant__selected-row .worktop-variant__stepper{grid-column:1/-1}.worktop-variant.is-wizard .worktop-variant__mobile-cta,.worktop-variant.is-wizard .worktop-variant__drawer-overlay{display:none!important}.worktop-variant.is-wizard{padding-bottom:16px}.worktop-variant.is-wizard .worktop-variant__wizard-nav{position:static;bottom:auto;z-index:4;padding-bottom:max(12px,env(safe-area-inset-bottom))}.worktop-variant__field input,.worktop-variant__field select,.worktop-variant__field textarea{font-size:16px}.worktop-variant__wizard-nav .btn,.worktop-variant__ghost-button{font-size:1.25rem;padding:10px 8px}}',
      '@media (max-width:430px){.worktop-variant__wizard-nav{grid-template-columns:1fr}.worktop-variant__steps button{font-size:1.12rem}.worktop-variant__lead{font-size:1.45rem}.worktop-variant__notice{font-size:1.3rem}}'
    ].join('');
    document.head.appendChild(style);
  }

  function fillSelect(select, rows, current) {
    if (!select) return;
    select.innerHTML = rows.map(row => {
      const label = row.label || row;
      return '<option value="' + escapeAttr(label) + '"' + (label === current ? ' selected' : '') + '>' + escapeHtml(label) + '</option>';
    }).join('');
  }

  function renderPieces() {
    if (!els.pieces) return;
    els.pieces.innerHTML = state.pieces.map((piece, index) => '<div class="worktop-variant__piece" data-piece-index="' + index + '"><div class="worktop-variant__piece-title"><span>Plan ' + (index + 1) + '</span>' + (state.pieces.length > 1 ? '<button type="button" class="worktop-variant__remove" data-remove-piece>Retirer</button>' : '') + '</div><div class="worktop-variant__piece-grid">' + numberField('Longueur (mm)', 'lengthMm', piece.lengthMm) + numberField('Largeur (mm)', 'widthMm', piece.widthMm) + numberField('Quantité', 'quantity', piece.quantity) + '</div></div>').join('');
  }

  function numberField(label, key, value) {
    return '<label class="worktop-variant__field"><span>' + escapeHtml(label) + '</span><input type="number" min="0" inputmode="numeric" value="' + Number(value || 0) + '" data-piece-field="' + key + '"></label>';
  }

  function optionCard(option, mode) {
    const qty = Number(state.quantities[option.handle] || 0);
    const selected = qty > 0;
    const image = mediaFrame(option.image_url || '', option.label || '');
    const priceHtml = option.category === 'decoupe' && option.pricing_model === 'quote_only'
      ? ''
      : '<p class="worktop-variant__option-price">' + escapeHtml(optionPriceLabel(option)) + '</p>';
    if (mode === 'toggle') {
      return '<article class="worktop-variant__option ' + (selected ? 'is-selected' : '') + '" data-option-handle="' + escapeAttr(option.handle) + '">' + image + '<div class="worktop-variant__option-body"><p class="worktop-variant__option-title">' + escapeHtml(option.label || '') + '</p>' + priceHtml + '<p class="worktop-variant__option-description">' + escapeHtml(option.description || '') + '</p></div><button type="button" class="worktop-variant__product-button" data-toggle-option>' + (selected ? 'Ajouté à ma demande' : 'Ajouter à ma demande') + '</button></article>';
    }
    return '<article class="worktop-variant__option ' + (selected ? 'is-selected' : '') + '" data-option-handle="' + escapeAttr(option.handle) + '">' + image + '<div class="worktop-variant__option-body"><p class="worktop-variant__option-title">' + escapeHtml(option.label || '') + '</p>' + priceHtml + '<p class="worktop-variant__option-description">' + escapeHtml(option.description || '') + '</p></div><div class="worktop-variant__stepper"><button type="button" data-option-minus>-</button><span>' + qty + '</span><button type="button" data-option-plus>+</button></div></article>';
  }

  function optionPriceLabel(option) {
    if (option.pricing_model === 'quote_only') return option.unit_label || 'À chiffrer';
    const price = numeric(option.price_ttc);
    if (price === 0) return 'Inclus';
    return formatMoney(price) + ' / ' + (option.unit_label || 'unité');
  }

  function mediaFrame(src, alt, modifier) {
    const classes = 'worktop-variant__media-frame' + (modifier ? ' ' + modifier : '');
    return '<span class="' + classes + '"><img src="' + escapeAttr(src || '') + '" alt="' + escapeAttr(alt || '') + '" loading="lazy"></span>';
  }

  function renderOptions() {
    if (els.unitOptions) els.unitOptions.innerHTML = options.filter(option => option.category === 'decoupe' || option.category === 'faconnage').map(option => optionCard(option, 'toggle')).join('');
    if (els.accessoryOptions) els.accessoryOptions.innerHTML = options.filter(option => option.category === 'accessoire').map(accessoryTypeCard).join('');
  }

  function accessoryTypeCard(option) {
    const category = option.productCategory || '';
    const products = accessoryProducts.filter(product => product.category === category);
    const selectedCount = selectedAccessoryCount(category);
    const imageUrl = accessoryTypeImageUrl(option, products);
    return '<button type="button" class="worktop-variant__type-card ' + (selectedCount ? 'is-selected' : '') + '" data-open-accessory-picker="' + escapeAttr(category) + '" style="--accessory-image-scale:' + accessoryTypeImageScale(category) + '">' + mediaFrame(imageUrl, option.label || categoryTitle(category), 'worktop-variant__media-frame--type') + '<span class="worktop-variant__type-body"><span class="worktop-variant__type-title">' + escapeHtml(option.label || categoryTitle(category)) + '</span><span class="worktop-variant__type-meta">' + products.length + ' modèles disponibles · Compatibilité vérifiée selon votre découpe' + (selectedCount ? ' · ' + selectedCount + ' ajouté(s)' : '') + '</span><span class="worktop-variant__type-meta">' + escapeHtml(option.description || '') + '</span><span class="worktop-variant__type-action">Choisir ou demander conseil</span></span></button>';
  }

  function accessoryTypeImageUrl(option, products) {
    const productImageUrl = products.find(product => product.image_url)?.image_url || '';
    if ((option.productCategory || '') === 'prise') return productImageUrl || option.image_url || '';
    return option.image_url || productImageUrl || '';
  }

  function renderBacksplash() {
    if (!els.backsplash) return;
    const pieces = state.backsplash.pieces?.length ? state.backsplash.pieces : [defaultBacksplashPiece()];
    state.backsplash.pieces = pieces;
    els.backsplash.innerHTML = '<label class="worktop-variant__checkbox"><input type="checkbox" data-backsplash-enabled ' + (state.backsplash.enabled ? 'checked' : '') + '><span><strong>Ajouter une crédence assortie (même matière, même finition)</strong><small>Ajoutez les dimensions principales. Nous ajusterons le détail et les découpes avec vous.</small></span></label><div class="worktop-variant__backsplash-list" ' + (state.backsplash.enabled ? '' : 'hidden') + '>' + pieces.map((piece, index) => '<div class="worktop-variant__backsplash-item" data-backsplash-index="' + index + '"><div class="worktop-variant__piece-title"><span>Crédence ' + (index + 1) + '</span>' + (pieces.length > 1 ? '<button type="button" class="worktop-variant__remove" data-remove-backsplash>Retirer</button>' : '') + '</div><div class="worktop-variant__backsplash-grid">' + backsplashNumber('Longueur (mm)', 'lengthMm', piece.lengthMm) + backsplashNumber('Hauteur (mm)', 'heightMm', piece.heightMm) + backsplashNumber('Quantité', 'quantity', piece.quantity) + backsplashNumber('Nombre de découpe de prises à prévoir', 'outletCutouts', piece.outletCutouts) + '</div></div>').join('') + '</div>';
  }

  function backsplashNumber(label, key, value) {
    return '<label class="worktop-variant__field"><span>' + escapeHtml(label) + '</span><input type="number" min="0" inputmode="numeric" value="' + Number(value || 0) + '" data-backsplash-field="' + key + '"></label>';
  }

  function renderAccessoryProducts() {
    if (!els.accessoryPanel) return;
    const requestRows = selectedAccessoryRequestRows();
    const productRows = selectedAccessoryProductRows();
    if (!requestRows.length && !productRows.length) {
      els.accessoryPanel.innerHTML = '';
      return;
    }
    els.accessoryPanel.innerHTML = '<section class="worktop-variant__accessory-section"><h3>Accessoires sélectionnés</h3><p class="worktop-variant__help">Ces besoins et produits sont ajoutés à votre demande. Nous confirmerons compatibilité, disponibilité et prix final avec vous.</p><div class="worktop-variant__selected-list">' + requestRows.map(selectedAccessoryRequestRow).join('') + productRows.map(selectedAccessoryProductRow).join('') + '</div></section>';
  }

  function selectedAccessoryProductRow(row) {
    const product = row.product;
    const display = productDisplay(product, row.variant);
    return '<article class="worktop-variant__selected-row" data-accessory-product="' + escapeAttr(product.handle) + '" style="--accessory-image-scale:' + selectedAccessoryImageScale(product.category) + '">' + mediaFrame(display.image_url || product.image_url || '', product.title, 'worktop-variant__media-frame--selected') + '<div><strong>' + escapeHtml(product.title) + '</strong><p class="worktop-variant__selected-meta">' + escapeHtml(accessorySelectionMeta(row)) + '</p></div><div class="worktop-variant__stepper"><button type="button" data-product-minus>-</button><span>' + row.quantity + '</span><button type="button" data-product-plus>+</button></div></article>';
  }

  function selectedAccessoryRequestRow(row) {
    const option = row.option || {};
    return '<article class="worktop-variant__selected-row" data-generic-accessory="' + escapeAttr(row.category) + '">' + mediaFrame(option.image_url || '', genericAccessoryTitle(row.category), 'worktop-variant__media-frame--selected') + '<div><strong>' + escapeHtml(genericAccessoryTitle(row.category)) + '</strong><p class="worktop-variant__selected-meta">Modèle à définir · Nous vous conseillerons une référence adaptée · à chiffrer</p></div><div class="worktop-variant__stepper"><button type="button" data-generic-accessory-minus>-</button><span>' + row.quantity + '</span><button type="button" data-generic-accessory-plus>+</button></div></article>';
  }

  function openAccessoryPicker(category) {
    state.picker.category = category || state.picker.category || 'evier';
    state.picker.query = '';
    state.picker.material = 'all';
    state.picker.brand = 'all';
    state.picker.installation = 'all';
    state.picker.visible = 12;
    if (els.pickerSearch) els.pickerSearch.value = '';
    if (els.pickerMaterial) els.pickerMaterial.value = 'all';
    if (els.pickerBrand) els.pickerBrand.value = 'all';
    if (els.pickerInstallation) els.pickerInstallation.value = 'all';
    renderPicker();
    if (els.picker) els.picker.hidden = false;
    if (els.pickerOverlay) els.pickerOverlay.hidden = false;
    document.body.classList.add('worktop-picker-open');
    setTimeout(() => els.pickerSearch?.focus(), 40);
  }

  function closeAccessoryPicker() {
    if (els.picker) els.picker.hidden = true;
    if (els.pickerOverlay) els.pickerOverlay.hidden = true;
    document.body.classList.remove('worktop-picker-open');
  }

  function filteredPickerProducts() {
    const query = normalize(state.picker.query);
    const material = state.picker.material || 'all';
    const brand = state.picker.brand || 'all';
    const installation = state.picker.installation || 'all';
    let rows = accessoryProducts.filter(product => product.category === state.picker.category);
    if (query) {
      rows = rows.filter(product => {
        const variantTerms = (product.variants || []).flatMap(variant => [variant.label, variant.color, variant.reference]);
        const technical = product.technical || {};
        const terms = [
          product.title,
          product.vendor,
          product.brand,
          product.badge,
          product.description,
          product.reference,
          product.sku,
          product.model,
          product.range,
          product.material,
          technical.connection,
          technical.function,
          technical.finish,
          technical.productCategory,
          technical.socketCategory,
          ...(Array.isArray(technical.connectionFilter) ? technical.connectionFilter : [technical.connectionFilter]),
          ...(Array.isArray(technical.typeFilter) ? technical.typeFilter : [technical.typeFilter]),
          ...(Array.isArray(technical.productCategoryFilter) ? technical.productCategoryFilter : [technical.productCategoryFilter]),
          ...(Array.isArray(technical.featureFilter) ? technical.featureFilter : [technical.featureFilter]),
          materialFilterValue(product),
          ...activeThirdFilterValues(product),
          ...variantTerms,
        ];
        return normalize(terms.join(' ')).includes(query);
      });
    }
    if (material !== 'all') rows = rows.filter(product => materialFilterValue(product) === material);
    if (brand !== 'all') rows = rows.filter(product => (product.brand || product.vendor || '') === brand);
    if (installation !== 'all') rows = rows.filter(product => activeThirdFilterValues(product).includes(installation));
    if (state.picker.sort === 'price-asc') rows = rows.slice().sort((a, b) => Number(productDisplay(a).price_ttc || 0) - Number(productDisplay(b).price_ttc || 0));
    if (state.picker.sort === 'price-desc') rows = rows.slice().sort((a, b) => Number(productDisplay(b).price_ttc || 0) - Number(productDisplay(a).price_ttc || 0));
    if (state.picker.sort === 'title-asc') rows = rows.slice().sort((a, b) => String(a.title).localeCompare(String(b.title), 'fr'));
    return rows;
  }

  function populatePickerSelect(select, values, current, allLabel) {
    if (!select) return current || 'all';
    const rows = Array.from(new Set(values.filter(Boolean))).sort((a, b) => String(a).localeCompare(String(b), 'fr'));
    const selected = rows.includes(current) ? current : 'all';
    select.innerHTML = '<option value="all">' + escapeHtml(allLabel) + '</option>' + rows.map(value => '<option value="' + escapeAttr(value) + '"' + (value === selected ? ' selected' : '') + '>' + escapeHtml(filterOptionLabel(value)) + '</option>').join('');
    select.value = selected;
    return selected;
  }

  function filterOptionLabel(value) {
    if (value === 'Encastree') return 'Encastrée';
    if (value === 'A fleur') return 'À fleur';
    if (value === 'Solution fenetre') return 'Solution fenêtre';
    if (value === 'Percage plan de travail') return 'Perçage plan de travail';
    if (value === 'Affleurant a encastrer') return 'Affleurant à encastrer';
    return value;
  }

  function renderPicker() {
    if (!els.pickerGrid) return;
    const category = state.picker.category || 'evier';
    const categoryProducts = accessoryProducts.filter(product => product.category === category);
    const thirdFilter = thirdFilterConfig(category);
    if (els.pickerTitle) els.pickerTitle.textContent = categoryTitle(category);
    if (els.pickerThirdLabel) els.pickerThirdLabel.textContent = thirdFilter.label;
    state.picker.material = populatePickerSelect(els.pickerMaterial, categoryProducts.map(materialFilterValue), state.picker.material, 'Tous les matériaux');
    state.picker.brand = populatePickerSelect(els.pickerBrand, categoryProducts.map(product => product.brand || product.vendor || ''), state.picker.brand, 'Toutes les marques');
    state.picker.installation = populatePickerSelect(els.pickerInstallation, categoryProducts.flatMap(thirdFilter.values), state.picker.installation, thirdFilter.allLabel);
    if (els.pickerSort) els.pickerSort.value = state.picker.sort || 'featured';
    const rows = filteredPickerProducts();
    const visibleRows = rows.slice(0, state.picker.visible);
    els.pickerGrid.classList.add('is-picker-grid');
    els.pickerGrid.innerHTML = visibleRows.map(productCard).join('');
    renderGenericAccessoryRequest();
    renderBrandAccessoryNote(category);
    if (els.pickerCount) els.pickerCount.textContent = rows.length + ' modèle(s) disponible(s) dans cette typologie. ' + selectedAccessoryCount(category) + ' besoin(s) ajouté(s).';
    if (els.pickerLoadMore) els.pickerLoadMore.hidden = visibleRows.length >= rows.length;
  }

  function renderGenericAccessoryRequest() {
    if (!els.pickerGeneric) return;
    const category = state.picker.category || 'evier';
    const quantity = numeric(state.accessoryRequests?.[category]?.quantity);
    const requestLabel = genericAccessoryTitle(category).toLowerCase();
    const title = genericAccessoryTitle(category);
    els.pickerGeneric.innerHTML = '<div class="worktop-variant__generic-request"><div><h3>Pas encore décidé ?</h3><p>Ajoutez simplement « ' + escapeHtml(requestLabel) + ' » : nous vous proposerons une référence compatible après étude de votre projet.</p></div><div class="worktop-variant__generic-request-action" data-generic-accessory="' + escapeAttr(category) + '">' + (quantity > 0 ? '<p class="worktop-variant__generic-request-status">' + escapeHtml(title) + ' x ' + quantity + '</p><div class="worktop-variant__stepper"><button type="button" data-generic-accessory-minus>-</button><span>' + quantity + '</span><button type="button" data-generic-accessory-plus>+</button></div>' : '<button type="button" class="worktop-variant__ghost-button" data-generic-accessory-add>Ajouter à ma demande</button>') + '</div></div>';
  }

  function renderBrandAccessoryNote(category) {
    if (!els.pickerGeneric || !['evier', 'mitigeur'].includes(category)) return;
    els.pickerGeneric.insertAdjacentHTML('beforeend', '<p class="worktop-variant__brand-note">Toute la gamme Bradano est disponible sur demande. Si vous ne trouvez pas la référence souhaitée, ajoutez une demande sans modèle précis.</p>');
  }

  function categoryTitle(category) {
    if (category === 'evier') return 'Choisir un évier';
    if (category === 'mitigeur') return 'Choisir un mitigeur';
    if (category === 'prise') return 'Choisir une prise intégrée';
    return 'Choisir un accessoire';
  }

  function genericAccessoryTitle(category) {
    if (category === 'evier') return 'Évier à intégrer';
    if (category === 'mitigeur') return 'Mitigeur à intégrer';
    if (category === 'prise') return 'Prise électrique à intégrer';
    return 'Accessoire à intégrer';
  }

  function accessoryPriceLabel(product, selectedLabel) {
    const display = productDisplay(product, selectedLabel);
    const price = display.price_public_ttc ?? display.price_ttc ?? product.price_public_ttc ?? product.price_ttc;
    if (product.pricing_model === 'quote_only') {
      return price ? 'Prix public indicatif : ' + formatMoney(price) + ' TTC · à chiffrer au devis' : 'Prix sur demande · à chiffrer au devis';
    }
    return price ? 'Prix TTC : ' + formatMoney(price) : 'Prix à confirmer';
  }

  function accessorySelectionMeta(row) {
    const product = row.product;
    const display = row.variantData || productDisplay(product, row.variant);
    return [
      product.brand || product.vendor || categoryTitle(product.category),
      display.reference ? 'Réf. ' + display.reference : '',
      display.label || row.variant || '',
      accessoryPriceLabel(product, display.label || row.variant),
    ].filter(Boolean).join(' · ');
  }

  function productCard(product) {
    const selected = state.accessoryProducts[product.handle];
    const qty = Number(selected?.quantity || 0);
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const defaultVariant = variants[0]?.label || '';
    const selectedVariant = selected?.variant || state.accessoryProductVariants?.[product.handle] || defaultVariant;
    const display = productDisplay(product, selectedVariant);
    const technical = product.technical || {};
    const technicalMeta = [
      display.reference ? 'Réf. ' + display.reference : '',
      product.range || '',
      technical.cabinetWidthCm ? 'Meuble ' + technical.cabinetWidthCm + ' cm' : '',
      technical.drillHoleMm ? 'Perçage Ø' + technical.drillHoleMm + ' mm' : '',
      technical.connection || '',
    ].filter(Boolean).join(' · ');
    const variantField = variants.length > 1 ? '<label class="worktop-variant__field worktop-variant__product-select"><span>Coloris</span><select data-accessory-variant>' + variants.map(variant => '<option value="' + escapeAttr(variant.label) + '"' + (variant.label === display.label ? ' selected' : '') + '>' + escapeHtml(variant.label) + '</option>').join('') + '</select></label>' : '';
    const badge = product.category === 'prise' ? '' : '<span class="worktop-variant__product-badge">' + escapeHtml(product.badge || product.category) + '</span>';
    return '<article class="worktop-variant__product ' + (qty > 0 ? 'is-selected' : '') + '" data-accessory-product="' + escapeAttr(product.handle) + '" style="--accessory-image-scale:' + accessoryImageScale(product.category) + '">' + mediaFrame(display.image_url || product.image_url || '', product.title) + '<div class="worktop-variant__product-body">' + badge + '<p class="worktop-variant__product-title">' + escapeHtml(product.title) + '</p><p class="worktop-variant__product-price">' + escapeHtml(accessoryPriceLabel(product, display.label)) + '</p>' + (technicalMeta ? '<p class="worktop-variant__product-description">' + escapeHtml(technicalMeta) + '</p>' : '') + '<p class="worktop-variant__product-description">' + escapeHtml(product.description || '') + '</p>' + variantField + '</div>' + (qty > 0 ? '<div class="worktop-variant__stepper"><button type="button" data-product-minus>-</button><span>' + qty + '</span><button type="button" data-product-plus>+</button></div>' : '<button type="button" class="worktop-variant__product-button" data-product-add>Ajouter à ma demande</button>') + '</article>';
  }

  function selectedBasePriceM2(finish, thickness) {
    const rows = Array.isArray(config.priceRows) ? config.priceRows : [];
    const selected = rows.find(row => (row.finish || row.finition) === state.finish && row.thickness === state.thickness);
    if (selected && numeric(selected.price) > 0) return numeric(selected.price);
    return numeric(thickness.basePriceM2) * numeric(finish.multiplier || 1);
  }

  function calculate() {
    const finish = (config.finishes || []).find(row => row.label === state.finish) || { multiplier: 1 };
    const thickness = (config.thicknesses || []).find(row => row.label === state.thickness) || { basePriceM2: 0 };
    const area = state.pieces.reduce((sum, piece) => sum + (numeric(piece.lengthMm) * numeric(piece.widthMm) / 1000000) * Math.max(1, numeric(piece.quantity)), 0);
    const basePriceM2 = selectedBasePriceM2(finish, thickness);
    const baseTotal = area * basePriceM2;
    const cutsToPlan = selectedOptionsByCategory(['decoupe', 'faconnage']);
    let accessoriesTotal = 0;
    let quoteOnlyAccessories = 0;
    for (const [handle, quantity] of Object.entries(state.quantities)) {
      const option = optionByHandle(handle);
      const qty = numeric(quantity);
      if (!option || qty <= 0) continue;
      if (option.category === 'accessoire') {
        if (option.pricing_model === 'quote_only') quoteOnlyAccessories += qty;
        else accessoriesTotal += numeric(option.price_ttc) * qty;
      }
    }
    for (const row of selectedAccessoryProductRows()) {
      if (row.product.pricing_model === 'quote_only') quoteOnlyAccessories += row.quantity;
      else accessoriesTotal += numeric(row.variantData?.price_ttc ?? row.product.price_ttc) * row.quantity;
    }
    for (const row of selectedAccessoryRequestRows()) quoteOnlyAccessories += row.quantity;
    const backsplashOption = optionByHandle(state.backsplash.optionHandle || 'credence-12-mm');
    const backsplashPieces = state.backsplash.enabled ? (state.backsplash.pieces || []).map(normalizeBacksplashPiece) : [];
    const backsplashPiecesCount = backsplashPieces.reduce((sum, piece) => sum + Math.max(1, numeric(piece.quantity)), 0);
    const backsplashSurfaceTotal = state.backsplash.enabled && backsplashOption
      ? backsplashPieces.reduce((sum, piece) => sum + numeric(piece.lengthMm) * numeric(piece.heightMm) / 1000000 * Math.max(1, numeric(piece.quantity)) * numeric(backsplashOption.price_ttc), 0)
      : 0;
    const backsplashOutletCutouts = state.backsplash.enabled ? backsplashPieces.reduce((sum, piece) => sum + Math.max(0, numeric(piece.outletCutouts)), 0) : 0;
    const backsplashOutletTotal = backsplashOutletCutouts * numeric(config.backsplashOutletCutPriceTtc || 43.68);
    const backsplashTotal = backsplashSurfaceTotal + backsplashOutletTotal;
    const grandTotal = baseTotal + accessoriesTotal + backsplashTotal;
    return { area, basePriceM2, baseTotal, cutsToPlan, backsplashPieces, backsplashPiecesCount, backsplashSurfaceTotal, backsplashOutletCutouts, backsplashOutletTotal, backsplashTotal, accessoriesTotal, quoteOnlyAccessories, grandTotal };
  }

  function updateSummary() {
    const totals = calculate();
    if (els.area) els.area.textContent = formatArea(totals.area);
    if (els.baseTotal) els.baseTotal.textContent = formatMoney(totals.baseTotal);
    if (els.cutsTotal) els.cutsTotal.textContent = totals.cutsToPlan.length ? 'À prévoir' : 'Aucune';
    if (els.backsplashTotal) els.backsplashTotal.textContent = formatMoney(totals.backsplashTotal);
    if (els.accessoriesTotal) els.accessoriesTotal.textContent = totals.quoteOnlyAccessories && !totals.accessoriesTotal ? 'À chiffrer' : formatMoney(totals.accessoriesTotal) + (totals.quoteOnlyAccessories ? ' + à chiffrer' : '');
    if (els.grandTotal) els.grandTotal.textContent = formatMoney(totals.grandTotal);
    if (els.mobileTotal) els.mobileTotal.textContent = formatMoney(totals.grandTotal);
    if (els.summaryLines) els.summaryLines.innerHTML = buildSummaryLines(totals);
    if (els.summary) els.summary.value = buildSummary(totals);
    if (els.payload) els.payload.value = JSON.stringify(buildPayload(totals), null, 2);
    persistState();
  }

  function buildSummaryLines(totals) {
    const productRows = selectedAccessoryProductRows();
    const requestRows = selectedAccessoryRequestRows();
    const accessoryLabels = [
      ...requestRows.map(row => genericAccessoryTitle(row.category) + ' x ' + row.quantity),
      ...productRows.map(row => row.product.title + (row.variant ? ' - ' + row.variant : '') + ' x ' + row.quantity),
    ];
    const rows = [
      ['Matière', [config.material, config.coloris].filter(Boolean).join(' ')],
      ['Finition', state.finish + ' · ' + state.thickness],
      ['Plans', String(state.pieces.length) + ' plan(s) · ' + formatArea(totals.area)],
      ['Découpes', totals.cutsToPlan.length ? totals.cutsToPlan.map(row => row.option.label).join(', ') : 'Aucune'],
      ['Crédence murale', state.backsplash.enabled ? totals.backsplashPiecesCount + ' crédence(s)' + (totals.backsplashOutletCutouts ? ' · ' + totals.backsplashOutletCutouts + ' découpe(s) de prises' : '') : 'Non'],
      ['Accessoires', accessoryLabels.length ? accessoryLabels.join(', ') : 'Aucun produit sélectionné'],
    ];
    return rows.map(row => '<div class="worktop-variant__summary-line"><span>' + escapeHtml(row[0]) + '</span><span>' + escapeHtml(row[1]) + '</span></div>').join('');
  }

  function selectedOptionsByCategory(categories) {
    return Object.entries(state.quantities)
      .map(([handle, quantity]) => ({ option: optionByHandle(handle), quantity: numeric(quantity) }))
      .filter(row => row.option && row.quantity > 0 && categories.includes(row.option.category));
  }

  function selectedAccessoryProductRows() {
    return Object.entries(state.accessoryProducts)
      .map(([handle, selection]) => {
        const product = productByHandle(handle);
        const selectionObject = selection && typeof selection === 'object' ? selection : { quantity: selection };
        const defaultVariant = product?.variants?.[0]?.label || '';
        const variant = selectionObject.variant || defaultVariant;
        return { product, quantity: numeric(selectionObject.quantity), variant, variantData: product ? productDisplay(product, variant) : {} };
      })
      .filter(row => row.product && row.quantity > 0);
  }

  function selectedAccessoryRequestRows() {
    return Object.entries(state.accessoryRequests || {})
      .map(([category, request]) => ({ category, option: accessoryOptionByCategory(category), quantity: numeric(request.quantity) }))
      .filter(row => row.category && row.quantity > 0);
  }

  function selectedAccessoryCount(category) {
    const productCount = selectedAccessoryProductRows().filter(row => row.product.category === category).reduce((sum, row) => sum + row.quantity, 0);
    const requestCount = selectedAccessoryRequestRows().filter(row => row.category === category).reduce((sum, row) => sum + row.quantity, 0);
    return productCount + requestCount;
  }

  function buildSummary(totals) {
    const lines = [];
    const contact = readContactFields();
    lines.push('Demande de devis plan de travail');

    addSummarySection(lines, 'Projet');
    lines.push('Produit : ' + (config.productTitle || root.querySelector('.worktop-variant__title')?.textContent?.trim() || 'Plan de travail'));
    lines.push('Matière / coloris : ' + [config.material, config.coloris].filter(Boolean).join(' '));
    lines.push('Finition : ' + state.finish);
    lines.push('Épaisseur : ' + state.thickness);

    addSummarySection(lines, 'Dimensions');
    state.pieces.forEach((piece, index) => lines.push('Plan ' + (index + 1) + ' : ' + piece.lengthMm + ' x ' + piece.widthMm + ' mm, quantité ' + piece.quantity));
    lines.push('Surface totale : ' + formatArea(totals.area));

    addSummarySection(lines, 'Découpes à prévoir');
    appendOptionLines(lines, 'Besoins indiqués', totals.cutsToPlan);

    addSummarySection(lines, 'Accessoires à prévoir');
    const requests = selectedAccessoryRequestRows();
    const products = selectedAccessoryProductRows();
    if (requests.length || products.length) {
      if (requests.length) {
        lines.push('Demandes sans modèle précis :');
        requests.forEach(row => lines.push('- ' + genericAccessoryTitle(row.category) + ' x ' + row.quantity + ' - modèle à définir / à chiffrer'));
      }
      if (products.length) {
        lines.push('Modèles sélectionnés :');
        products.forEach(row => lines.push('- ' + row.product.title + ' / ' + row.variant + ' x ' + row.quantity + ' - ' + accessorySelectionMeta(row)));
      }
    } else {
      lines.push('Aucun');
    }

    addSummarySection(lines, 'Crédence murale');
    if (state.backsplash.enabled) {
      totals.backsplashPieces.forEach((piece, index) => {
        lines.push('Crédence ' + (index + 1) + ' : ' + piece.lengthMm + ' x ' + piece.heightMm + ' mm, quantité ' + piece.quantity + ', découpes de prises à prévoir ' + piece.outletCutouts);
      });
      lines.push('Découpes de prises dans la crédence : ' + totals.backsplashOutletCutouts + (totals.backsplashOutletCutouts ? ' x ' + formatMoney(config.backsplashOutletCutPriceTtc || 43.68) + ' TTC' : ''));
    } else {
      lines.push('Non sélectionné');
    }

    addSummarySection(lines, 'Sous-totaux indicatifs TTC');
    lines.push('Matière : ' + formatMoney(totals.baseTotal));
    lines.push('Découpes à prévoir : ' + (totals.cutsToPlan.length ? 'à reprendre ensemble, non additionnées à l’estimation' : 'aucune sélection'));
    lines.push('Crédence murale : ' + formatMoney(totals.backsplashTotal));
    lines.push('Accessoires : ' + formatMoney(totals.accessoriesTotal) + (totals.quoteOnlyAccessories ? ' + à chiffrer' : ''));
    lines.push('Total estimatif TTC : ' + formatMoney(totals.grandTotal));

    if (contact.message) {
      addSummarySection(lines, 'Message client');
      lines.push(contact.message);
    }

    const hasContact = contact.name || contact.email || contact.phone || contact.address1 || contact.postalCode || contact.city || contact.consent;
    if (hasContact) {
      addSummarySection(lines, 'Coordonnées');
      if (contact.name) lines.push('Nom : ' + contact.name);
      if (contact.email) lines.push('Email : ' + contact.email);
      if (contact.phone) lines.push('Téléphone : ' + contact.phone);
      if (contact.address1) lines.push('Adresse postale : ' + contact.address1);
      if (contact.postalCode) lines.push('Code postal : ' + contact.postalCode);
      if (contact.city) lines.push('Ville : ' + contact.city);
      if (contact.country) lines.push('Pays : ' + contact.country);
      lines.push('Consentement recontact : ' + (contact.consent ? 'Oui' : 'Non'));
    }

    return lines.join('\n');
  }

  function addSummarySection(lines, title) {
    if (lines.length) lines.push('');
    lines.push(title);
  }

  function appendOptionLines(lines, title, rows) {
    if (!rows.length) {
      lines.push(title + ' : aucune sélection');
      return;
    }
    lines.push(title + ' :');
    rows.forEach(row => lines.push('- ' + row.option.label + (row.quantity > 1 ? ' x ' + row.quantity : '') + (row.option.pricing_model === 'quote_only' ? ' - à prévoir' : ' - ' + optionPriceLabel(row.option))));
  }

  function buildEmailSummary(totals) {
    const contact = readContactFields();
    const requests = selectedAccessoryRequestRows();
    const products = selectedAccessoryProductRows();
    const projectRows = [
      ['Produit', config.productTitle || root.querySelector('.worktop-variant__title')?.textContent?.trim() || 'Plan de travail'],
      ['Matière / coloris', [config.material, config.coloris].filter(Boolean).join(' ')],
      ['Finition', state.finish],
      ['Épaisseur', state.thickness],
      ['Total estimatif TTC', formatMoney(totals.grandTotal)],
    ];
    const contactRows = [
      ['Nom', contact.name],
      ['Email', contact.email],
      ['Téléphone', contact.phone],
      ['Adresse projet', [contact.address1, contact.postalCode, contact.city, contact.country].filter(Boolean).join(', ')],
      ['Consentement recontact', contact.consent ? 'Oui' : 'Non'],
    ];
    const dimensionRows = [
      ...state.pieces.map((piece, index) => 'Plan ' + (index + 1) + ' : ' + piece.lengthMm + ' x ' + piece.widthMm + ' mm, quantité ' + piece.quantity),
      'Surface totale : ' + formatArea(totals.area),
    ];
    const cutRows = totals.cutsToPlan.length
      ? totals.cutsToPlan.map(row => row.option.label + (row.quantity > 1 ? ' x ' + row.quantity : '') + ' - à prévoir')
      : ['Aucune sélection'];
    const accessoryRows = [
      ...requests.map(row => genericAccessoryTitle(row.category) + ' x ' + row.quantity + ' - modèle à définir / à chiffrer'),
      ...products.map(row => row.product.title + ' / ' + row.variant + ' x ' + row.quantity + ' - ' + accessorySelectionMeta(row)),
    ];
    const backsplashRows = state.backsplash.enabled
      ? [
          ...totals.backsplashPieces.map((piece, index) => 'Crédence ' + (index + 1) + ' : ' + piece.lengthMm + ' x ' + piece.heightMm + ' mm, quantité ' + piece.quantity + ', découpes de prises à prévoir ' + piece.outletCutouts),
          'Découpes de prises dans la crédence : ' + totals.backsplashOutletCutouts,
        ]
      : ['Non sélectionné'];
    const subtotalRows = [
      ['Matière', formatMoney(totals.baseTotal)],
      ['Découpes à prévoir', totals.cutsToPlan.length ? 'À reprendre ensemble, non additionnées à l’estimation' : 'Aucune sélection'],
      ['Crédence murale', formatMoney(totals.backsplashTotal)],
      ['Accessoires', formatMoney(totals.accessoriesTotal) + (totals.quoteOnlyAccessories ? ' + à chiffrer' : '')],
      ['Total estimatif TTC', formatMoney(totals.grandTotal)],
    ];

    return '<div style="font-family:Arial,sans-serif;color:#111827;line-height:1.45;">'
      + '<h2 style="margin:0 0 16px;font-size:20px;">Nouvelle demande de devis plan de travail</h2>'
      + emailSection('Client', emailRows(contactRows))
      + emailSection('Projet', emailRows(projectRows))
      + emailSection('Dimensions', emailList(dimensionRows))
      + emailSection('Découpes à prévoir', emailList(cutRows))
      + emailSection('Accessoires à prévoir', accessoryRows.length ? emailList(accessoryRows) : emailMuted('Aucun'))
      + emailSection('Crédence murale', emailList(backsplashRows))
      + emailSection('Sous-totaux indicatifs TTC', emailRows(subtotalRows))
      + (contact.message ? emailSection('Message client', '<p style="margin:0;white-space:pre-wrap;">' + escapeHtml(contact.message) + '</p>') : '')
      + emailSection('Suivi interne', emailRows([
          ['ID demande', state.requestId],
          ['Source', window.location.href],
        ]))
      + '</div>';
  }

  function emailSection(title, body) {
    return '<section style="margin:0 0 18px;padding:14px 0 0;border-top:1px solid #e5e7eb;"><h3 style="margin:0 0 8px;font-size:16px;">' + escapeHtml(title) + '</h3>' + body + '</section>';
  }

  function emailRows(rows) {
    const visibleRows = rows.filter(row => row[1] !== undefined && row[1] !== null && row[1] !== '');
    if (!visibleRows.length) return emailMuted('Non renseigné');
    return '<table style="width:100%;border-collapse:collapse;">' + visibleRows.map(row => '<tr><th style="width:170px;padding:4px 12px 4px 0;text-align:left;vertical-align:top;color:#4b5563;font-weight:600;">' + escapeHtml(row[0]) + '</th><td style="padding:4px 0;vertical-align:top;">' + escapeHtml(row[1]) + '</td></tr>').join('') + '</table>';
  }

  function emailList(rows) {
    const visibleRows = rows.filter(Boolean);
    if (!visibleRows.length) return emailMuted('Aucun');
    return '<ul style="margin:0;padding-left:18px;">' + visibleRows.map(row => '<li style="margin:0 0 5px;">' + escapeHtml(row) + '</li>').join('') + '</ul>';
  }

  function emailMuted(text) {
    return '<p style="margin:0;color:#6b7280;">' + escapeHtml(text) + '</p>';
  }

  function buildPayload(totals) {
    return {
      type: 'worktop_quote_request',
      status: 'new',
      requestId: state.requestId,
      sourceUrl: window.location.href,
      productTitle: config.productTitle || root.querySelector('.worktop-variant__title')?.textContent?.trim() || '',
      experienceMode: config.experienceMode || '',
      contact: readContactFields(),
      summary: buildSummary(totals),
      summaryHtml: buildEmailSummary(totals),
      totals: {
        areaM2: round(totals.area),
        baseTotal: round(totals.baseTotal),
        cutsToPlanCount: totals.cutsToPlan.length,
        backsplashPiecesCount: round(totals.backsplashPiecesCount),
        backsplashOutletCutouts: round(totals.backsplashOutletCutouts),
        backsplashOutletTotal: round(totals.backsplashOutletTotal),
        backsplashTotal: round(totals.backsplashTotal),
        accessoriesTotal: round(totals.accessoriesTotal),
        quoteOnlyAccessoriesCount: round(totals.quoteOnlyAccessories),
        grandTotal: round(totals.grandTotal),
      },
      configuration: {
        material: config.material || '',
        coloris: config.coloris || '',
        productTitle: config.productTitle || root.querySelector('.worktop-variant__title')?.textContent?.trim() || '',
        finish: state.finish,
        thickness: state.thickness,
        pieces: state.pieces.map(normalizePiece),
        quantities: state.quantities,
        accessoryRequests: state.accessoryRequests,
        backsplash: {
          ...state.backsplash,
          pieces: (state.backsplash.pieces || []).map(normalizeBacksplashPiece),
        },
      },
      selectedOptions: selectedOptionsByCategory(['decoupe', 'faconnage']).map(row => ({ handle: row.option.handle, label: row.option.label, category: row.option.category, quantity: row.quantity, pricing_model: row.option.pricing_model })),
      selectedAccessoryRequests: selectedAccessoryRequestRows().map(row => ({ category: row.category, label: genericAccessoryTitle(row.category), quantity: row.quantity, pricing_model: 'quote_only', model: 'to_define' })),
      selectedAccessoryProducts: selectedAccessoryProductRows().map(row => {
        const selected = row.variantData || productDisplay(row.product, row.variant);
        return {
          sourceType: row.product.sourceType || row.product.source_type || 'metaobject',
          handle: row.product.handle,
          productId: selected.productId || row.product.productId || row.product.product_id || '',
          variantId: selected.variantId || row.product.variantId || row.product.variant_id || '',
          title: row.product.title,
          brand: row.product.brand || row.product.vendor || '',
          category: row.product.category,
          range: row.product.range || '',
          model: row.product.model || '',
          reference: selected.reference || row.product.reference || '',
          color: selected.color || row.product.color || '',
          variant: selected.label || row.variant || '',
          image_url: selected.image_url || row.product.image_url || '',
          quantity: row.quantity,
          pricing_model: row.product.pricing_model || row.product.pricingMode || 'quote_only',
          price_ttc: round(selected.price_ttc ?? row.product.price_ttc),
          price_public_ttc: round(selected.price_public_ttc ?? selected.price_ttc ?? row.product.price_public_ttc ?? row.product.price_ttc),
          source_url: selected.source_url || row.product.source_url || row.product.sourceUrl || '',
          technical: row.product.technical || {},
        };
      }),
    };
  }

  function round(value) {
    return Math.round(Number(value || 0) * 100) / 100;
  }

  function readContactFields() {
    const result = {};
    els.contactFields.forEach(field => {
      const key = field.dataset.worktopContactField;
      if (!key) return;
      result[key] = field.type === 'checkbox' ? field.checked : field.value.trim();
    });
    return result;
  }

  function restoreContactFields(contact) {
    els.contactFields.forEach(field => {
      const key = field.dataset.worktopContactField;
      if (!key || contact[key] === undefined) return;
      if (field.type === 'checkbox') field.checked = Boolean(contact[key]);
      else field.value = contact[key];
    });
  }

  function persistState() {
    try {
      const { requestId, ...draftState } = state;
      window.localStorage.setItem(storageKey, JSON.stringify({ version: config.version, state: draftState, contact: readContactFields() }));
    } catch (_) {}
  }

  function loadSavedState() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
      return parsed?.version === config.version ? parsed : null;
    } catch (_) {}
    return null;
  }

  function shouldSuppressSummaryDrawer() {
    return isWizard && window.matchMedia('(max-width: 767px)').matches;
  }

  function openSummary() {
    if (shouldSuppressSummaryDrawer()) {
      goToStep(4);
      closeSummary();
      return;
    }
    root.classList.add('is-summary-open');
    document.body.classList.add('worktop-variant-drawer-open');
  }

  function closeSummary() {
    root.classList.remove('is-summary-open');
    document.body.classList.remove('worktop-variant-drawer-open');
  }

  function normalizeSummaryDrawer() {
    if (shouldSuppressSummaryDrawer()) closeSummary();
  }

  function initWizardLayout() {
    if (!isWizard) {
      if (els.steps) els.steps.hidden = true;
      if (els.wizardNav) els.wizardNav.hidden = true;
      return;
    }
    if (els.steps) els.steps.hidden = false;
    if (els.wizardNav) els.wizardNav.hidden = false;
    const mobileAction = els.mobileToggle?.querySelector('span:last-child');
    if (mobileAction) mobileAction.textContent = 'Finaliser';
    if (els.wizardFormHost && els.form && !els.wizardFormHost.contains(els.form)) {
      els.wizardFormHost.appendChild(els.form);
    }
    state.currentStep = clampStep(state.currentStep);
    renderWizardStep();
    normalizeSummaryDrawer();
  }

  function clampStep(step) {
    return Math.min(4, Math.max(1, Number(step) || 1));
  }

  function renderWizardStep() {
    if (!isWizard) return;
    const step = clampStep(state.currentStep);
    state.currentStep = step;
    els.stepPanels.forEach(panel => panel.classList.toggle('is-active', Number(panel.dataset.worktopStep) === step));
    els.stepButtons.forEach(button => {
      const active = Number(button.dataset.worktopStepButton) === step;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-current', active ? 'step' : 'false');
    });
    if (els.prevStep) {
      els.prevStep.hidden = step === 1;
      els.prevStep.textContent = 'Étape précédente';
    }
    if (els.wizardNav) els.wizardNav.classList.toggle('is-final-step', step === 4);
    updateNextStepLabel();
    persistState();
  }

  function updateNextStepLabel() {
    if (!els.nextStep) return;
    if (state.currentStep === 4) {
      els.nextStep.hidden = true;
      els.nextStep.style.display = 'none';
      return;
    }
    els.nextStep.hidden = false;
    els.nextStep.style.display = '';
    if (state.currentStep === 3) {
      const compact = window.matchMedia('(max-width: 1180px)').matches;
      els.nextStep.textContent = compact ? 'Coordonnées' : 'Renseigner mes coordonnées';
      return;
    }
    els.nextStep.textContent = 'Étape suivante';
  }

  function validateCurrentStep() {
    if (!isWizard) return true;
    if (state.currentStep === 1) {
      const invalidPiece = state.pieces.find(piece => numeric(piece.lengthMm) <= 0 || numeric(piece.widthMm) <= 0 || numeric(piece.quantity) <= 0);
      if (invalidPiece) {
        setStatus('Renseignez des dimensions valides avant de continuer.', 'error');
        return false;
      }
    }
    setStatus('', '');
    return true;
  }

  function goToStep(step, skipValidation = false) {
    if (!isWizard) return;
    if (state.currentStep === 4 && step > 4) return;
    const next = clampStep(step);
    if (!skipValidation && next > state.currentStep && !validateCurrentStep()) return;
    state.currentStep = next;
    renderWizardStep();
    root.querySelector('.worktop-variant__content')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function setStatus(message, type) {
    if (!els.status) return;
    els.status.textContent = message;
    els.status.classList.toggle('is-success', type === 'success');
    els.status.classList.toggle('is-error', type === 'error');
  }

  function setSubmitting(isSubmitting) {
    if (els.form) els.form.dataset.submitting = isSubmitting ? 'true' : 'false';
    if (els.submit) {
      els.submit.disabled = Boolean(isSubmitting);
      els.submit.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    }
  }

  function setSubmitted() {
    if (els.form) els.form.dataset.submitted = 'true';
    if (els.submit) {
      els.submit.disabled = true;
      els.submit.setAttribute('aria-busy', 'false');
      els.submit.textContent = 'Demande envoyée';
    }
  }

  async function submitEndpoint(event) {
    event.preventDefault();
    if (els.form?.dataset.submitting === 'true' || els.form?.dataset.submitted === 'true') return;
    if (!els.form?.checkValidity()) {
      els.form.reportValidity();
      return;
    }
    const totals = calculate();
    const payload = buildPayload(totals);
    if (els.summary) els.summary.value = payload.summary;
    if (els.payload) els.payload.value = JSON.stringify(payload, null, 2);
    const endpoint = root.dataset.worktopQuoteEndpoint || '';
    if (!endpoint) {
      setStatus('Mode test : le payload est prêt. Renseigner l’URL du Worker pour créer le metaobject Shopify.', 'success');
      return;
    }
    setSubmitting(true);
    setStatus('Envoi de la demande...', '');
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.error || 'Erreur endpoint');
      setSubmitted();
      setStatus('Votre demande a bien été envoyée. Si vous avez un plan, un croquis ou des documents précisant les dimensions de votre projet, transmettez-les à contact@marbrerie-madone.fr en indiquant votre nom. Ces éléments nous aideront à préparer un devis précis.', 'success');
    } catch (error) {
      setSubmitting(false);
      setStatus('Impossible d’enregistrer la demande pour le moment. Réessayez ou contactez-nous.', 'error');
      console.error(error);
    }
  }

  function attachEvents() {
    root.addEventListener('touchend', event => {
      if (event.target.closest('select, input, textarea, .worktop-variant__field')) event.stopPropagation();
    });
    els.finish?.addEventListener('change', event => { state.finish = event.target.value; updateSummary(); });
    els.thickness?.addEventListener('change', event => { state.thickness = event.target.value; updateSummary(); });
    root.addEventListener('input', event => {
      const pieceEl = event.target.closest('[data-piece-index]');
      if (pieceEl && event.target.matches('[data-piece-field]')) {
        state.pieces[Number(pieceEl.dataset.pieceIndex)][event.target.dataset.pieceField] = numeric(event.target.value);
        updateSummary();
      }
      if (event.target.matches('[data-backsplash-field]')) {
        const backsplashEl = event.target.closest('[data-backsplash-index]');
        if (!backsplashEl) return;
        const index = Number(backsplashEl.dataset.backsplashIndex);
        state.backsplash.pieces[index][event.target.dataset.backsplashField] = numeric(event.target.value);
        updateSummary();
      }
      if (event.target.matches('[data-worktop-contact-field]')) updateSummary();
    });
    root.addEventListener('change', event => {
      if (event.target.matches('[data-backsplash-enabled]')) {
        state.backsplash.enabled = event.target.checked;
        if (state.backsplash.enabled && !state.backsplash.pieces?.length) state.backsplash.pieces = [defaultBacksplashPiece()];
        renderBacksplash();
        updateSummary();
      }
      if (event.target.matches('[data-accessory-variant]')) {
        const productEl = event.target.closest('[data-accessory-product]');
        if (!productEl) return;
        const handle = productEl.dataset.accessoryProduct;
        const current = state.accessoryProducts[handle];
        const currentQuantity = current && typeof current === 'object' ? current.quantity : current;
        if (numeric(currentQuantity) > 0) state.accessoryProducts[handle] = { quantity: numeric(currentQuantity), variant: event.target.value };
        else state.accessoryProductVariants[handle] = event.target.value;
        renderAccessoryProducts();
        renderPicker();
        updateSummary();
      }
      if (event.target.matches('[data-worktop-contact-field]')) updateSummary();
    });
    root.addEventListener('click', event => {
      const stepButton = event.target.closest('[data-worktop-step-button]');
      if (stepButton) {
        const target = Number(stepButton.dataset.worktopStepButton);
        goToStep(target, target <= state.currentStep);
        return;
      }
      if (event.target.closest('[data-worktop-prev-step]')) {
        goToStep(state.currentStep - 1, true);
        return;
      }
      if (event.target.closest('[data-worktop-next-step]')) {
        goToStep(state.currentStep + 1);
        return;
      }
      const pieceEl = event.target.closest('[data-piece-index]');
      if (event.target.matches('[data-worktop-add-piece]')) {
        state.pieces.push({ lengthMm: 1800, widthMm: 650, quantity: 1 });
        renderPieces();
        updateSummary();
      }
      if (pieceEl && event.target.matches('[data-remove-piece]')) {
        state.pieces.splice(Number(pieceEl.dataset.pieceIndex), 1);
        renderPieces();
        updateSummary();
      }
      if (event.target.matches('[data-worktop-add-backsplash]')) {
        const wasEnabled = state.backsplash.enabled;
        state.backsplash.enabled = true;
        if (!state.backsplash.pieces?.length) state.backsplash.pieces = [defaultBacksplashPiece()];
        else if (wasEnabled) state.backsplash.pieces.push(defaultBacksplashPiece());
        renderBacksplash();
        updateSummary();
        return;
      }
      const backsplashEl = event.target.closest('[data-backsplash-index]');
      if (backsplashEl && event.target.matches('[data-remove-backsplash]')) {
        state.backsplash.pieces.splice(Number(backsplashEl.dataset.backsplashIndex), 1);
        if (!state.backsplash.pieces.length) state.backsplash.pieces = [defaultBacksplashPiece()];
        renderBacksplash();
        updateSummary();
        return;
      }
      const optionEl = event.target.closest('[data-option-handle]');
      if (optionEl && event.target.matches('[data-toggle-option]')) {
        const handle = optionEl.dataset.optionHandle;
        if (Number(state.quantities[handle] || 0) > 0) delete state.quantities[handle];
        else state.quantities[handle] = 1;
        renderOptions();
        updateSummary();
        return;
      }
      if (optionEl && event.target.matches('[data-option-plus], [data-option-minus]')) {
        const handle = optionEl.dataset.optionHandle;
        const delta = event.target.matches('[data-option-plus]') ? 1 : -1;
        state.quantities[handle] = Math.max(0, Number(state.quantities[handle] || 0) + delta);
        renderOptions();
        renderAccessoryProducts();
        updateSummary();
      }
      const pickerTrigger = event.target.closest('[data-open-accessory-picker]');
      if (pickerTrigger) {
        openAccessoryPicker(pickerTrigger.dataset.openAccessoryPicker);
      }
      const genericEl = event.target.closest('[data-generic-accessory]');
      if (genericEl && event.target.matches('[data-generic-accessory-add], [data-generic-accessory-plus], [data-generic-accessory-minus]')) {
        const category = genericEl.dataset.genericAccessory;
        const current = numeric(state.accessoryRequests?.[category]?.quantity);
        const delta = event.target.matches('[data-generic-accessory-minus]') ? -1 : 1;
        const quantity = Math.max(0, current + delta);
        if (quantity === 0) delete state.accessoryRequests[category];
        else state.accessoryRequests[category] = { quantity };
        renderOptions();
        renderAccessoryProducts();
        renderPicker();
        updateSummary();
      }
      const productEl = event.target.closest('[data-accessory-product]');
      if (productEl && event.target.matches('[data-product-add], [data-product-plus], [data-product-minus]')) {
        const handle = productEl.dataset.accessoryProduct;
        const product = productByHandle(handle);
        const defaultVariant = product?.variants?.[0]?.label || '';
        const currentSelection = state.accessoryProducts[handle];
        const current = currentSelection && typeof currentSelection === 'object' ? currentSelection : { quantity: currentSelection || 0, variant: state.accessoryProductVariants?.[handle] || defaultVariant };
        const delta = event.target.matches('[data-product-minus]') ? -1 : 1;
        const quantity = Math.max(0, Number(current.quantity || 0) + delta);
        if (quantity === 0) delete state.accessoryProducts[handle];
        else state.accessoryProducts[handle] = { quantity, variant: current.variant || defaultVariant };
        renderOptions();
        renderAccessoryProducts();
        renderPicker();
        updateSummary();
      }
    });
    els.mobileToggle?.addEventListener('click', () => {
      if (isWizard) {
        closeSummary();
        goToStep(4);
        return;
      }
      openSummary();
    });
    els.closeSummary?.addEventListener('click', closeSummary);
    els.overlay?.addEventListener('click', closeSummary);
    els.pickerClose?.addEventListener('click', closeAccessoryPicker);
    els.pickerOverlay?.addEventListener('click', closeAccessoryPicker);
    els.pickerSearch?.addEventListener('input', event => {
      state.picker.query = event.target.value;
      state.picker.visible = 12;
      renderPicker();
    });
    els.pickerMaterial?.addEventListener('change', event => {
      state.picker.material = event.target.value;
      state.picker.visible = 12;
      renderPicker();
    });
    els.pickerBrand?.addEventListener('change', event => {
      state.picker.brand = event.target.value;
      state.picker.visible = 12;
      renderPicker();
    });
    els.pickerInstallation?.addEventListener('change', event => {
      state.picker.installation = event.target.value;
      state.picker.visible = 12;
      renderPicker();
    });
    els.pickerSort?.addEventListener('change', event => {
      state.picker.sort = event.target.value;
      renderPicker();
    });
    els.pickerLoadMore?.addEventListener('click', () => {
      state.picker.visible += 12;
      renderPicker();
    });
    window.addEventListener('resize', () => {
      normalizeSummaryDrawer();
      updateNextStepLabel();
    });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      closeAccessoryPicker();
      closeSummary();
    });
    els.form?.addEventListener('submit', submitEndpoint);
  }

  function escapeHtml(value) {
    return String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' })[char]);
  }
  function escapeAttr(value) { return escapeHtml(value); }
  function normalize(value) {
    return String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  function createRequestId() {
    const random = window.crypto?.randomUUID?.() || Math.random().toString(36).slice(2) + '-' + Date.now().toString(36);
    return String(random).toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 80);
  }

  initWizardLayout();
  fillSelect(els.finish, config.finishes || [{ label: state.finish }], state.finish);
  fillSelect(els.thickness, config.thicknesses || [{ label: state.thickness }], state.thickness);
  renderPieces();
  renderOptions();
  renderBacksplash();
  renderAccessoryProducts();
  attachEvents();
  updateSummary();
})();